/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APISimpleAddress
 */
export interface APISimpleAddress {
    /**
     * 
     * @type {string}
     * @memberof APISimpleAddress
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APISimpleAddress
     */
    address1?: string;
    /**
     * 
     * @type {string}
     * @memberof APISimpleAddress
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof APISimpleAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof APISimpleAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof APISimpleAddress
     */
    country?: string;
}

/**
 * Check if a given object implements the APISimpleAddress interface.
 */
export function instanceOfAPISimpleAddress(value: object): value is APISimpleAddress {
    return true;
}

export function APISimpleAddressFromJSON(json: any): APISimpleAddress {
    return APISimpleAddressFromJSONTyped(json, false);
}

export function APISimpleAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISimpleAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'address1': json['address_1'] == null ? undefined : json['address_1'],
        'address2': json['address_2'] == null ? undefined : json['address_2'],
        'zipCode': json['zip_code'] == null ? undefined : json['zip_code'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function APISimpleAddressToJSON(value?: APISimpleAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'address_1': value['address1'],
        'address_2': value['address2'],
        'zip_code': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

